"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var default_locale_contentful_content_accessor_1 = require("../../../../accessors/contentful/default-locale-contentful-content-accessor");

var FootnoteRenderer_1 = require("./FootnoteRenderer/FootnoteRenderer");

function composeEntryLinkRendererUsing(contentTypeRendererMap) {
  return function (node, children) {
    var _a, _b, _c, _d, _e;

    var item = (_a = node.data) === null || _a === void 0 ? void 0 : _a.target;
    var contentType = (_e = (_d = (_c = (_b = item) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.contentType) === null || _d === void 0 ? void 0 : _d.sys) === null || _e === void 0 ? void 0 : _e.id;

    var nodeRenderer = contentTypeRendererMap[contentType] || function () {
      return null;
    };

    var itemAccessor = new default_locale_contentful_content_accessor_1.DefaultLocaleContentfulContentAccessor(item);
    return nodeRenderer(itemAccessor, node, children);
  };
}

exports.composeEntryLinkRendererUsing = composeEntryLinkRendererUsing;
exports.defaultEntryItemRendererMap = {
  Footnote: FootnoteRenderer_1.renderFootnote
};